module.exports = __webpack_public_path__ + "img/DealerIcons-i2-On.80822ac.jpg";